import { RejectLeavePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import RejectLeave from 'modules/timeoff/components/RejectLeave'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const RejectLeavePage = () => {
  const { leave_id: leaveId } = useStrictParams<'leave_id'>()
  const onClose = useOnClose()

  const { data } = useQuery(RejectLeavePageDocument, {
    variables: {
      leaveId: leaveId,
    },
  })

  const leaveEmployee = data?.timeoff.leave?.employee

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return <RejectLeave leaveId={leaveId} onClose={onClose} leaveEmployeeId={leaveEmployee.id} />
}

export default RejectLeavePage
